<template>
	<div class="table-net-income-details">
		<b-table-simple bordered responsive>
			<b-thead>
				<b-tr>
					<b-th class="text-white">Customer Name</b-th>
					<b-th class="text-white">{{ customer.name }}</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr
					v-if="customer.incomes.main.income_type_id === 2 && customer.incomes.main.business_income_type === 'Borang B'">
					<b-th scope="row">Borang B</b-th>
					<b-td>{{ customer.incomes.main.company_bank_statement | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr
					v-else-if="customer.incomes.main.income_type_id === 2 && customer.incomes.main.business_income_type === 'Company Bank Statement'">
					<b-th scope="row">Company Bank Statement</b-th>
					<b-td>{{ customer.incomes.main.company_bank_statement | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-else>
					<b-th scope="row">Salary</b-th>
					<b-td>{{ customer.incomes.main.monthly_salary | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Fixed Allowance</b-th>
					<b-td>{{ customer.incomes.main.fixed_allowance | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Average Variable Income</b-th>
					<b-td>{{ customer.incomes.main.av_var_inc | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Average Commission Income</b-th>
					<b-td>{{ customer.incomes.main.av_com_inc | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Average Bonus Income</b-th>
					<b-td>{{ customer.incomes.main.av_bonus_inc | moneyFormatter }}</b-td>
				</b-tr>

				<b-tr variant="primary" class="font-weight-bolder">
					<b-th scope="row">Gross Income</b-th>
					<b-td>{{ customer.incomes.main.gross_income | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Income Tax</b-th>
					<b-td>{{ customer.incomes.main.income_tax | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 1">
					<b-th scope="row">Payslip / Other Deduction</b-th>
					<b-td>{{ customer.incomes.main.total_other_deduction | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">EPF</b-th>
					<b-td>{{ customer.incomes.main.epf | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">SOCSO</b-th>
					<b-td>{{ customer.incomes.main.sosco | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Rental Income</b-th>
					<b-td>{{ customer.incomes.main.total_rental_inc | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">Other Income</b-th>
					<b-td>{{ customer.incomes.main.total_other_inc | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr variant="danger" class="font-weight-bolder">
					<b-th scope="row">Net Income</b-th>
					<b-td>{{ customer.incomes.main.net_income | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 3 || customer.incomes.main.income_type_id === 5">
					<b-th scope="row">Payslip / Other Deduction</b-th>
					<b-td>{{ customer.incomes.main.total_other_deduction | moneyFormatter }}</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 3 || customer.incomes.main.income_type_id === 5">
					<b-th scope="row">DSR (Net Income Ratio)</b-th>
					<b-td>{{ customer.incomes.main.net_income_ratio }}%</b-td>
				</b-tr>
				<b-tr v-if="customer.incomes.main.income_type_id === 3 || customer.incomes.main.income_type_id === 5"
					variant="danger" class="font-weight-bolder">
					<b-th scope="row">Net Balance Income</b-th>
					<b-td>{{ customer.incomes.main.balance_net_income | moneyFormatter }}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<small class="text-break">*Bonus, Rental and Other Income are added after Net Income.</small>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
export default {
	props: ['customer'],
	name: 'table-net-income-details',
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
		}
	},
}
</script>